import React from 'react';
import PropTypes from 'prop-types';

export default function PepIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18.526 17.312'
      className={className}
    >
      <path
        id='Caminho_12246'
        data-name='Caminho 12246'
        d='M521.734,214.81h-2.407v17.312h2.407A1.126,1.126,0,0,0,522.86,231v-1.384h.666a1.044,1.044,0,1,0,0-2.084h-.666v-3.02h.666a1.044,1.044,0,1,0,0-2.087h-.666V219.4h.666a1.044,1.044,0,1,0,0-2.087h-.666v-1.384a1.123,1.123,0,0,0-1.126-1.123Zm-1.173,13.762a1.539,1.539,0,0,1,1.536-1.536h.5v.493h-.437a1.044,1.044,0,1,0,0,2.084h.431v.5h-.5a1.536,1.536,0,0,1-1.536-1.539Zm0-5.107a1.536,1.536,0,0,1,1.536-1.533h.5v.49h-.437a1.044,1.044,0,1,0,0,2.087h.431V225h-.5a1.539,1.539,0,0,1-1.536-1.536Zm1.536-6.638h.5v.49h-.437a1.044,1.044,0,1,0,0,2.087h.431v.49h-.5a1.533,1.533,0,1,1,0-3.067Zm-15.43-1.759h1.173a.879.879,0,0,0-.158.51v2.806h-1.026a.566.566,0,0,1-.557-.586v-2.175a.563.563,0,0,1,.557-.554Zm.267,3.671h.736v3.3h-.736a.566.566,0,0,1-.566-.566V219.3a.566.566,0,0,1,.56-.563Zm.5,3.879h.237v3.3h-.237c-.311,0-.709-.252-.709-.563v-2.175c-.006-.314.393-.566.7-.566Zm.712-6.684V230.99c0,.622.331,1.126.95,1.126h9.713V214.81H509.09c-.619,0-.95.5-.95,1.123Zm.991,5.949h2.773v-2.727h3.166v2.727h2.683v3.166H515.07v2.718H511.9v-2.727h-2.773Z'
        transform='translate(-506.099 -214.81)'
        fill={fill}
      />
    </svg>
  );
}

PepIcon.defaultProps = {
  fill: '#cacaca',
  width: 18.526,
  height: 17.312
};

PepIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
